/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchasedLeadsApiModel } from '../../models/purchased-leads-api-model';

export interface GetPurchase$Params {
  id: string;
}

export function getPurchase(http: HttpClient, rootUrl: string, params: GetPurchase$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchasedLeadsApiModel>> {
  const rb = new RequestBuilder(rootUrl, getPurchase.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchasedLeadsApiModel>;
    })
  );
}

getPurchase.PATH = '/marketplace/purchase/{id}';
